import ReactDOM from 'react-dom';
import React, { useRef, useEffect } from 'react';
import mapboxgl from 'mapbox-gl';
import turf from 'turf';

import Popup from './Popup';
import categoriesData from '../data/categories';
import limitData from '../data/sarria.json';
import { updateLayerVisibilitySingle } from '../utils/updateLayerVisibility';

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;

const categoryList = [];
const cateogriesWithPhotos = ['facanes', 'vegetacio', 'mobiliari-urba', 'arquitectura', 'fer-esport', 'desplacarse', 'descansar', 'esperar', 'jugar', 'passejar'];

categoriesData.forEach((categoria) => {
  categoria.children.forEach((subcategoria) => {
    if (subcategoria.children) {
      subcategoria.children.forEach((subsubcategoria) => categoryList.push(subsubcategoria.value));
    } else {
      categoryList.push(subcategoria.value);
    }
  });
});

const Map = ({ setMapbox }) => {
  const mapContainerRef = useRef(null);

  // initialize map when component mounts
  useEffect(() => {
    const map = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: 'mapbox://styles/monica1965/ckoyib10h0ddu17mfe9snf9fs',
      center: [2.123175, 41.397493],
      maxBounds: limitData.bounds, // wsen
      zoom: 15
    });

    // Add control navigation and disable zoom by default
    map.addControl(new mapboxgl.NavigationControl(), 'bottom-right');
    map.scrollZoom.disable();

    map.on('load', () => {
      /*
       * EXTERIOR DE SARRIÀ MÉS OPAC
       */
      map.addSource('mask', {
        type: 'geojson',
        data: turf.difference(turf.bboxPolygon(limitData.limits), turf.polygon(limitData.geometry))
      });

      map.addLayer({
        id: 'mask',
        source: 'mask',
        type: 'fill',
        paint: {
          'fill-color': '#EAEAEB',
          'fill-opacity': 0.8
        }
      });

      /*
       * ASSEGURAR QUE LES CAPES ESTAN AMAGADES PER DEFECTE
       */
      categoryList.forEach((subcategoria) => {
        updateLayerVisibilitySingle(map, subcategoria, 'none');
      });

      /*
       * POPUPS
       */
      // const botigues = map.getLayer('bar');
      const popup = new mapboxgl.Popup({
        closeButton: false,
        closeOnClick: false
      });

      cateogriesWithPhotos.forEach((layer) => {
        map.on('mouseenter', map.getLayer(layer).id, (e) => {
          map.getCanvas().style.cursor = 'pointer';

          const coordinates = e.features[0].geometry.coordinates.slice();

          // Ensure that if the map is zoomed out such that multiple
          // copies of the feature are visible, the popup appears
          // over the copy being pointed to.
          while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
            coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
          }

          const popupNode = document.createElement('div');
          ReactDOM.render(<Popup img={e.features[0].properties.Link} />, popupNode);

          popup.setLngLat(coordinates).setDOMContent(popupNode).addTo(map);
        });

        map.on('mouseleave', map.getLayer(layer).id, () => {
          map.getCanvas().style.cursor = '';
          popup.remove();
        });
      });

      /*
       * HABILITAR ZOOM
       */
      window.addEventListener('scroll', () => {
        if (
          mapContainerRef.current.getBoundingClientRect().top <= 0
          && mapContainerRef.current.getBoundingClientRect().top >= -10) {
          map.scrollZoom.enable();
        }
      });
    });

    // Duplicate map data so it can be passed to DOM elements
    setMapbox(map);

    // clean up on unmount
    return () => map.remove();
  }, []);

  return (
    <div className='map' ref={mapContainerRef} />
  );
};

export default Map;
